<template>
    <div ref="list" v-gsap.whenVisible.from="{ opacity: 0, y: -32 }" class="justify-center gap-8 grid mt-8 stone-list">
        <div v-for="(item, key) in items" :key ref="listItem" class="relative flex flex-col gap-4 max-lg:pl-8 w-full max-w-48 stone-list-item">
            <PageProductDetailCard
                :image="getStoneShapeImage(useFind(item, { title: 'shape' })?.value)"
                class="mx-auto w-3/4 grow stone-item-image"
            />
            <ul class="flex flex-col justify-center items-center">
                <li v-for="(el, index) in item" :key="index" class="flex items-center gap-2">
                    <h5 class="opacity-50 text-xs leading-2">{{ $t(`product.${el.title}.label`) }}</h5>
                    <p class="opacity-90 font-bold text-sm">{{ $t(`product.${el.title}.${el.value}`, el.value) }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts" setup>
interface ListItem {
    title: string;
    value: string;
}

interface Props {
    items: ListItem[][];
}

defineProps<Props>();
</script>

<style scoped>
/* .stone-item-image {
    transition: all 1s ease;
} */
.stone-list-item:not(:last-child)::after {
    content: "";
    position: absolute;
    top: 10%;
    left: -1rem;
    width: 1px;
    height: 80%;
    background-color: var(--color-primary);
    opacity: 0.25;
}
.stone-list-item:nth-child(2n):after {
    content: none;
}
@media (width >= 64rem /* 1024px */) {
    .stone-list-item:nth-child(2n):after {
        content: "";
    }
    .stone-list-item:nth-child(6n):after {
        content: none;
    }
}
</style>
